const data = [
  {
    title: 'MOST CREATIVE PEOPLE IN BUSINESS',
    description:
      'Leaders who are shaping the future of business in creative ways.',
    logo:
      'https://images.fastcompany.net/image/upload/v1536778764/fcweb/mcpnewlogo_d7dgyh.svg',
    image:
      'https://images.fastcompany.net/image/upload/w_280,ar_16:9,c_fill,g_auto,f_auto,q_auto:best/wp-cms/uploads/2022/08/p-1-margrethe-vestager-executive-vice-president-of-the-european-commission-for-a-europe-fit-for-the-digital-age-competition-most-creative-people-2022.webp',
    link: 'https://www.fastcompany.com/most-creative-people/list'
  },
  {
    title: 'INNOVATION by design',
    description:
      'The best products, services, interfaces, and design ideas in business.',
    logo:
      'https://images.fastcompany.net/image/upload/v1536781102/fcweb/IBD_small-icon-50x50px-fix_s2op0e.svg',
    image:
      'https://images.fastcompany.net/image/upload/w_280,ar_16:9,c_fill,g_auto,f_auto,q_auto:best/v1601651362/fcweb/IBD_2020_cevzec.jpg',
    link: 'https://www.fastcompany.com/innovation-by-design/2020'
  },
  {
    title: 'Most Innovative Companies',
    description:
      'Fast Company’s annual ranking of businesses that are making an outsize impact.',
    logo:
      'https://images.fastcompany.net/image/upload/v1536778764/fcweb/micnewlogo_ctvsdy.svg',
    image:
      'https://images.fastcompany.net/image/upload/w_280,ar_16:9,c_fill,g_auto,f_auto,q_auto:best/wp-cms/uploads/2022/03/p-1-mic-2022-canva.jpg',
    link: 'https://www.fastcompany.com/most-innovative-companies/list'
  },
  {
    title: 'World Changing Ideas',
    description:
      'Products, concepts, and policies that are pursuing innovation for good.',
    logo:
      'https://images.fastcompany.net/image/upload/v1536779048/fcweb/wcinewlogo_jebah8.svg',
    image:
      'https://images.fastcompany.net/image/upload/w_280,ar_16:9,c_fill,g_auto,f_auto,q_auto:best/v1651681311/FINAL_1d-2022-wci-opener-STILL.png',
    link: 'https://www.fastcompany.com/world-changing-ideas/list'
  }
];

export default data;
